import Button from '../Button';
// ═══════════════════════════════════════════════════════════════
// FILE: src/components/shared/ModalShell.jsx
// FILE VERSION: MODALSHELL-v1.7.39.1
// CHARLIE VERSION: v1.7.39
// CREATED: 2026-07-23
//
// Shared modal chrome. Used by Lobby, Tasks, and any future
// module needing a centered overlay modal. Extracted from
// Lobby.jsx (LOBBY-v1.7.38.4) during the component split.
// Zero logic changes from original.
// ═══════════════════════════════════════════════════════════════

const SLATE = 'var(--gov-text-primary)';
const BORDER = 'var(--gov-slate-200)';
const BORDER_SOFT = 'var(--gov-slate-100)';
const TEXT_MUTED = 'var(--gov-slate-500)';
const CRIMSON = 'var(--gov-brand-red)';

const NAVY = SLATE; // same navy used by MergePicker's own real header, for branded mode

export function ModalShell({ title, subtitle, onClose, width = 520, children, branded = false }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width, maxWidth: '94vw', maxHeight: '88vh', overflow: 'auto', boxShadow: '0 20px 60px rgba(15,23,42,0.3)' }}>
        {branded ? (
          // #1943 -- opt-in branded chrome, matching MergePicker's own real
          // header exactly (navy background, white text, pill Close button)
          // rather than the plain light header, which reads as a browser
          // dialog when stacked over an already-branded screen.
          <div style={{
            padding: '16px 22px', background: NAVY, color: '#fff',
            borderRadius: '12px 12px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>{title}</div>
              {subtitle && <div style={{ fontSize: 11, opacity: 0.75, marginTop: 3 }}>{subtitle}</div>}
            </div>
            <Button variant="secondary" size="sm" onClick={onClose} style={{ background: 'transparent', borderColor: 'rgba(255,255,255,0.3)', color: '#fff' }}>Close</Button>
          </div>
        ) : (
          <div style={{ padding: '14px 18px', borderBottom: `1px solid ${BORDER}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontWeight: 800, color: SLATE, fontSize: 16 }}>{title}</div>
              {subtitle && <div style={{ fontSize: 12, color: TEXT_MUTED, marginTop: 2 }}>{subtitle}</div>}
            </div>
            <Button variant="ghost" iconOnly onClick={onClose} style={{ background: BORDER_SOFT, width: 28, height: 28, color: TEXT_MUTED }}>×</Button>
          </div>
        )}
        <div style={{ padding: 18 }}>{children}</div>
      </div>
    </div>
  );
}

export function ModalActions({ onCancel, onConfirm, confirmLabel = 'Confirm', confirmDisabled = false, danger = false }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
      <Button variant="secondary" onClick={onCancel} style={{ color: SLATE, borderColor: BORDER }}>Cancel</Button>
      <Button
        variant="primary"
        color={danger ? CRIMSON : SLATE}
        onClick={onConfirm}
        disabled={confirmDisabled}
      >{confirmLabel}</Button>
    </div>
  );
}
